import React from 'react';

export type DrawerClosePosition = 'left' | 'right';

export interface DrawerLeftIconButton {
  icon: React.ReactNode;
  onClick: () => void | Promise<void>;
  custom?: React.ReactNode;
}

export interface DrawerRightButton {
  title?: React.ReactNode;
  onClick: () => void | Promise<void>;
  isDisabled?: boolean;
}

export interface DrawerTitle {
  iconSrc: string;
  text: string;
}

export type DrawerTitleContent = string | DrawerTitle | React.ReactElement;

export function isDrawerTitle(
  title?: DrawerTitleContent
): title is DrawerTitle {
  return Boolean(
    title && typeof title === 'object' && !React.isValidElement(title)
  );
}

export interface DrawerProps {
  isOpen: boolean;
  title?: DrawerTitleContent;
  subtitle?: React.ReactNode;
  bottom?: React.ReactNode;
  hasBottomMargin?: boolean;
  hasBottomBorder?: boolean;
  right?: DrawerRightButton;
  onSearch?: (value: string) => void;
  searchPlaceholder?: string;
  isInPortal?: boolean;
  className?: string;
  dataTestId?: string;
  isHeadFixed?: boolean;
  capitalizeTitle?: boolean;
  isHeadHidden?: boolean;
  isLoading?: boolean;
  background?: string;
  close?: () => void;
  closePosition?: DrawerClosePosition;
  left?: DrawerLeftIconButton;
  isAdaptive?: boolean;
}
